var _line, _circle, _circle2, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelevisionSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 50,
    viewBox: "0 0 80 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 74,
    y1: 25,
    x2: 37,
    y2: 25,
    stroke: "#B31B34",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 76,
    cy: 25,
    r: 4,
    transform: "rotate(90 76 25)",
    fill: "#B31B34"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    transform: "rotate(90 25 25)",
    fill: "#B31B34"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0001 30L35 30V16.25L15.0001 16.25L15.0001 30ZM26.2501 32.5V35H31.2501V37.5H18.7501V35H23.7501V32.5H13.7401C13.5759 32.499 13.4136 32.4657 13.2623 32.4018C13.1111 32.338 12.974 32.2449 12.8588 32.128C12.7436 32.0111 12.6526 31.8725 12.5911 31.7204C12.5295 31.5682 12.4986 31.4054 12.5001 31.2413L12.5001 15.0088C12.5001 14.3138 13.0688 13.75 13.7401 13.75L36.26 13.75C36.945 13.75 37.5 14.3112 37.5 15.0088V31.2413C37.5 31.9363 36.9313 32.5 36.26 32.5H26.2501Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelevisionSmall);
export default __webpack_public_path__ + "static/media/television-small.7cdc1b3f06c401f5c916865342bdcfcd.svg";
export { ForwardRef as ReactComponent };